import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface ImpersonateUserResponse {
  redirect_url: string
}

export function impersonateUserAction(userId: string): Promise<ApiResponse<ImpersonateUserResponse>> {
  return api.v2.post<ApiResponse<ImpersonateUserResponse>>(`/users/${userId}/impersonate`)
}
